// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__Qtfx4","logo":"styles_logo__hTa5C"};